import { CreatorsReducerState, defaultCreatorContactsFilters } from "types/creators";
import { fetchContactsThunk } from "./thunk";
import { createSlice } from "@reduxjs/toolkit";

const initialState: CreatorsReducerState = {
    loading: false,
    error: null,
    filters: defaultCreatorContactsFilters,
    applied_filter_id: null,
    total: 0,
    unprocessed: 0,
    failed: 0,
    filtered_lists: {}
}

const creatorsSlice = createSlice({
    name: 'creators',
    initialState,
    reducers: {
        updateCreatorsFilters: (state, action) => {
            state.filters = action.payload;
        },
        resetCreatorsState: (state) => {
            state = initialState;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchContactsThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchContactsThunk.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.error = null;
            const { filterId, filters, count, items, unprocessed, failed } = payload;
            const existingList = state.filtered_lists?.[filterId]?.list ?? [];
            const list = filters.page === 1 ? items : [...existingList, ...items]
            state.filtered_lists = {
                ...state.filtered_lists,
                [filterId]: {
                    list,
                    page: filters.page,
                    expired: false,
                    last_fetched_at: Date.now(),
                    has_more: count > list.length,
                    count
                }
            }
            state.applied_filter_id = filterId;
            if (!filters.unprocessed && !filters.has_error) {
                state.unprocessed = unprocessed;
                state.failed = failed;
                state.total = count;
            }
        })
        .addCase(fetchContactsThunk.rejected, (state) => {
            state.loading = false;
            state.error = null;
        })
    },
})

export const { updateCreatorsFilters, resetCreatorsState } = creatorsSlice.actions;
export default creatorsSlice.reducer;